import React, { useState } from 'react';
import { Loader, AlertCircle, Info } from 'lucide-react';
import { BACKEND_URL } from '../config';

const JoinDiscordStep2 = ({ token }) => {
  const [isVerifying, setIsVerifying] = useState(false);
  const [error, setError] = useState('');

  const handleVerify = async () => {
    setIsVerifying(true);
    setError('');

    try {
      const response = await fetch(`${BACKEND_URL}/api/onboarding`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'verify-nsl-role',
          token: token,
        }),
      });

      const data = await response.json();

      if (data.success) {
        window.location.reload();
      } else {
        if (data.notVerified) {
          setError('Aún no te has verificado en el canal #verify. Por favor verifícate primero y vuelve a intentar.');
        } else {
          setError(data.error || 'Error al verificar');
        }
      }
    } catch {
      setError('Error al verificar. Intenta de nuevo.');
    } finally {
      setIsVerifying(false);
    }
  };

  if (isVerifying) {
    return (
      <div className="text-center py-8">
        <Loader className="w-16 h-16 text-yellow-500 animate-spin mx-auto mb-6" />
        <h2 className="text-2xl font-bold text-white mb-4">Verificando...</h2>
        <p className="text-gray-400">Estamos verificando tu role en Discord.</p>
      </div>
    );
  }

  return (
    <div className="text-center py-8">
      <div className="text-7xl mb-6">🔍</div>
      <h2 className="text-3xl sm:text-4xl font-bold mb-4 bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
        ¿Ya te verificaste?
      </h2>
      <p className="text-gray-300 mb-8 text-lg">
        Recuerda que debes verificarte en NSL en el canal de <span className="text-[#5865F2] font-semibold">#verify</span>
      </p>

      <div className="max-w-md mx-auto mb-6 p-5 bg-gradient-to-r from-blue-500/20 to-purple-500/20 border-2 border-blue-400/50 rounded-xl shadow-lg shadow-blue-500/20 animate-pulse-subtle">
        <div className="flex items-start gap-3">
          <Info className="w-6 h-6 text-blue-400 flex-shrink-0 mt-1" />
          <div className="text-left">
            <p className="text-blue-300 font-bold text-base mb-2">⚠️ ¿NO VES EL CANAL #VERIFY?</p>
            <p className="text-gray-200 text-sm leading-relaxed">
              Si no aparece el canal <span className="text-[#5865F2] font-semibold">#verify</span>, es porque ya estás verificado como estudiante antiguo o acabas de completar la verificación. 
              <span className="block mt-2 text-yellow-300 font-semibold">👉 Continúa haciendo clic en "Ya estoy verificado"</span>
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-md mx-auto mb-8 p-6 bg-yellow-500/10 border border-yellow-500/30 rounded-xl">
        <p className="text-yellow-500 font-semibold text-sm mb-2">📋 Paso 2 de 3</p>
        <div className="text-left space-y-3">
          <p className="text-gray-300 text-sm">
            <span className="font-semibold text-white">1.</span> Ve al canal <span className="text-[#5865F2] font-semibold">#verify</span> en Discord
          </p>
          <p className="text-gray-300 text-sm">
            <span className="font-semibold text-white">2.</span> Completa el proceso de verificación del bot
          </p>
          <p className="text-gray-300 text-sm">
            <span className="font-semibold text-white">3.</span> Una vez verificado, regresa aquí y haz clic en "Ya estoy verificado"
          </p>
        </div>
      </div>

      <button
        onClick={handleVerify}
        disabled={isVerifying}
        className={`w-full max-w-md mx-auto font-bold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg ${
          isVerifying
            ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
            : 'bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black hover:shadow-yellow-500/50'
        }`}
      >
        {isVerifying ? 'Verificando...' : 'Ya estoy verificado'}
      </button>

      {error && (
        <div className="max-w-md mx-auto mt-4 flex items-start gap-2 p-3 bg-red-500/10 border border-red-500/20 rounded-lg">
          <AlertCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
          <p className="text-red-500 text-sm text-left">{error}</p>
        </div>
      )}
    </div>
  );
};

export default JoinDiscordStep2;